module.exports = __webpack_public_path__ + "static/img/12.3a8ba71.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/eng/12.png
// module id = nijz
// module chunks = 0